import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { Content, Block } from "./components";

export const EmptyGainLossStatisticsBlock = () => {
  const { t } = useTranslation();

  return (
    <Content>
      <Block>
        <Typography color="textSecondary" variant="body4">
          {t("investment.details.gainLossStatistics.gainAndLoss")}
        </Typography>
        <Typography variant="body2">N/A</Typography>
      </Block>

      <Block>
        <Typography color="textSecondary" variant="body4">
          {t("investment.details.gainLossStatistics.returnOnInvestment")}
        </Typography>
        <Typography variant="body2">N/A</Typography>
      </Block>
      <Block>
        <Typography color="textSecondary" variant="body4">
          {t("investment.details.gainLossStatistics.realizedGains")}
        </Typography>
        <Typography variant="body2">N/A</Typography>
      </Block>
      <Block>
        <Typography color="textSecondary" variant="body4">
          {t("investment.details.gainLossStatistics.twror")}
        </Typography>
        <Typography variant="body2">N/A</Typography>
      </Block>
    </Content>
  );
};
